/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
declare var alertify:any;
@Component({
  templateUrl:'./notice.html'
})

export class Notice implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService
  ){}

  private data:any=[];

  private imagePath:string='';

  ngOnInit(): void {
    this.getPath();

  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private getData(){
    this.http.getData(API.noticeList).then(res=>{
      this.data=res.data;
     /* this.data.url=this.imagePath+this.data.url;*/
      for (let i=0;i<this.data.length;i++){
        this.data[i].url = this.imagePath+this.data[i].url;

      }



        if(typeof this.data.startTime=='object'){
          this.data.startTime='';
        }
        if(typeof this.data.endTime=='object'){
          this.data.endTime='';
        }

    });
  }

  private editNotice(id:number){
    this.router.navigate(['index/notice',id]);
  }


  private delete(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.notice+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }



}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/notice/notice.component.ts